import { SecurityZoneListPanel } from '@/components/features/applications/security-zones/SecurityZoneListPanel';
import { isIntrusionZone } from '@/lib/enum-resolvers';

export function IntrusionZonesPanel() {
  return (
    <SecurityZoneListPanel
      title="Intrusion Zones"
      description="Monitor security zones and intrusion detection"
      emptyTitle="No Security Zones"
      emptyDescription="No intrusion zones are configured on this device."
      emptyIconPath="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
      noZonesTitle="No User Zones"
      noZonesDescription="No user-configurable intrusion zones are active on this device."
      filterFn={isIntrusionZone}
      showConnectedToggle
      connectedToggleLabel="Intrusion Sensor Connected"
    />
  );
}
